import { render, staticRenderFns } from "./restore_captain.vue?vue&type=template&id=11d438bb&scoped=true&"
import script from "./restore_captain.vue?vue&type=script&lang=js&"
export * from "./restore_captain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d438bb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11d438bb')) {
      api.createRecord('11d438bb', component.options)
    } else {
      api.reload('11d438bb', component.options)
    }
    module.hot.accept("./restore_captain.vue?vue&type=template&id=11d438bb&scoped=true&", function () {
      api.rerender('11d438bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/captains/actions/restore_captain.vue"
export default component.exports